<template>
  <VSlideGroup
    ref="easyStepSlider"
    v-model="selectedOption"
    show-arrows
    :direction="props.direction"
    :center-active="true"
    selected-class="active"
    class="easy-step-slider"
    @wheel.prevent="onMouseWheel"
  >
    <VSlideGroupItem
      v-for="opt in options"
      :key="opt"
      #default="{ isSelected, toggle }"
      :value="opt"
    >
      <button
        class="easy-step-slider--button"
        :class="isSelected ? 'active' : 'not-active'"
        data-cy="button--easy-step-slider"
        @click="toggle"
      >
        {{ opt }}
      </button>
    </VSlideGroupItem>

    <template #prev>
      <button>
        <i class="icon icon-chevron-up" />
      </button>
    </template>

    <template #next>
      <button>
        <i class="icon icon-chevron-down" />
      </button>
    </template>
  </VSlideGroup>
</template>

<script setup lang="ts">
import { VSlideGroup } from "vuetify/components/VSlideGroup";
import { computed, ref } from "vue";
import { StepSliderDirection, VuetifyOrientation } from "../types";

interface Props {
  modelValue: string;
  options: string[];
  direction?: VuetifyOrientation;
}
const props = withDefaults(defineProps<Props>(), {
  direction: VuetifyOrientation.Vertical,
});

interface Emits {
  (e: "update:modelValue", value: string): void;
}
const emit = defineEmits<Emits>();

const selectedOption = computed({
  get: () => props.modelValue,
  set: value => emit("update:modelValue", value),
});

const easyStepSlider = ref<VSlideGroup | null>(null);
const onMouseWheel = ({ deltaY }: { deltaY: number }) => {
  const stepDirection = deltaY > 0 ? StepSliderDirection.Next : StepSliderDirection.Prev;
  easyStepSlider.value?.scrollTo(stepDirection);
};
</script>
